<style lang="scss" scoped>
.setting-container {
  background-color: transparent;
  padding: 10px 0;
}

.setting-form {
  width: 100%;
}

.form-item {
  margin-bottom: 24px;
}

.form-label {
  color: #c0c4cc;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.el-select,
.el-input {
  width: 100%;
}

.el-input__inner,
.el-select-dropdown {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(65, 159, 255, 0.3);
  color: #ffffff;
}

.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.el-select-dropdown {
  border: 1px solid rgba(65, 159, 255, 0.5);
}

.el-select-dropdown__item {
  color: black;
}

.el-select-dropdown__item:hover {
  background-color: rgba(65, 159, 255, 0.2);
}

.el-select-dropdown__item.selected {
  background-color: rgba(65, 159, 255, 0.3);
  color: #419fff;
}

.el-input-number__decrease,
.el-input-number__increase {
  border-color: rgba(65, 159, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.05);
  color: #419fff;
}

.el-input-number__decrease:hover,
.el-input-number__increase:hover {
  background-color: rgba(65, 159, 255, 0.2);
}

.tips {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  margin-top: 6px;
  line-height: 1.4;
}

/* 主题适配 */
::v-deep .el-form-item__error {
  color: #ff4d4f;
}
</style>

<template>
  <div class="setting-container">
    <el-form ref="settingForm" class="setting-form" :model="form" :rules="validationRules" label-width="120px">
      <!-- 表格展示模式 -->
      <el-form-item :label="$t('xianshimoshi')" prop="displayMode" class="form-item">
        <el-select v-model="form.displayMode" :placeholder="$t('qingxuanzezanshimoshi')" @change="handleModeChange">
          <el-option :label="$t('fanyemoshi')" value="page"></el-option>
          <el-option :label="$t('gundongmoshi')" value="scroll"></el-option>
        </el-select>
        <div class="tips">
          {{ $t('fanyemoshitishi') }}
        </div>
      </el-form-item>

      <!-- 翻页模式专属配置 - 每页条数 -->
      <el-form-item v-if="form.displayMode === 'page'" :label="$t('meiyetiaoshu')" prop="pageSize" class="form-item">
        <el-input-number v-model="form.pageSize" :min="1" :max="50" :step="1" controls-position="right"></el-input-number>
        <div class="tips">
          {{ $t('meiyetiaoshutishi') }}
        </div>
      </el-form-item>

      <!-- 翻页模式专属配置 - 自动翻页时间 -->
      <el-form-item v-if="form.displayMode === 'page'" :label="$t('zidongfanyeshijian')" prop="autoPageTime" class="form-item">
        <el-input-number v-model="form.autoPageTime" :min="5" :max="60" :step="1" controls-position="right"></el-input-number>
        <span style="color: #C0C4CC; margin-left: 8px;">{{ $t('miao') }}</span>
        <div class="tips">
          {{ $t('zidongfanyeshijiantishi') }}
        </div>
      </el-form-item>

      <!-- 主题风格配置 -->
      <!-- <el-form-item :label="$t('kanbanzhutifengge')" prop="theme" class="form-item">
        <el-select v-model="form.theme" :placeholder="$t('qingxuanzezhutifengge')">
          <el-option :label="$t('heisezhuti')" value="black"></el-option>
          <el-option :label="$t('lansezhuti')" value="blue"></el-option>
        </el-select>
        <div class="tips">
          {{ $t('zhutifenggetishi') }}
        </div>
      </el-form-item> -->

      <!-- 数据刷新间隔 -->
      <el-form-item :label="$t('shuaxinshijianjiange')" prop="refreshInterval" class="form-item">
        <el-input-number v-model="form.refreshInterval" :min="60" :max="3600" :step="60" controls-position="right"></el-input-number>
        <span style="color: #C0C4CC; margin-left: 8px;">{{ $t('miao') }}</span>
        <div class="tips">
          {{ $t('shuaxinjiangetishi') }}
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_monitor_model_manage_setting',
  data() {
    return {
      form: {
        displayMode: 'page',
        pageSize: 10,
        autoPageTime: 10,
        theme: 'black',
        refreshInterval: 120
      },
      validationRules: {
        displayMode: [{ required: true, message: this.$t('qingxuanzebiaogezanshimoshi'), trigger: 'change' }],
        pageSize: [{ required: true, message: this.$t('qingshurumeiyetiaoshu'), trigger: 'blur' }, { type: 'number', min: 1, max: 50, message: this.$t('meiyetiaoshufanwei'), trigger: 'change' }],
        autoPageTime: [{ required: true, message: this.$t('qingshuruzidongfanyeshijian'), trigger: 'blur' }, { type: 'number', min: 5, max: 60, message: this.$t('zidongfanyeshijianfanwei'), trigger: 'change' }],
        theme: [{ required: true, message: this.$t('qingxuanzekanbanzhutifengge'), trigger: 'change' }],
        refreshInterval: [{ required: true, message: this.$t('qingshurushujuashuaxinjiange'), trigger: 'blur' }, { type: 'number', min: 60, max: 3600, message: this.$t('shuaxinjiangefanwei'), trigger: 'change' }]
      }
    };
  },
  mounted() {
    this.resetData();
  },
  methods: {
    resetData() {
      const monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING')) || {};

      // 表格展示模式配置
      this.form.displayMode = monitorSetting.displayMode || 'page';
      this.form.pageSize = monitorSetting.pageSize || 10;
      this.form.autoPageTime = monitorSetting.autoPageTime || 10;

      // 主题风格配置
      this.form.theme = monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE || 'black';

      // 数据刷新间隔配置
      this.form.refreshInterval = monitorSetting.refreshInterval || 120;

      // 限制参数范围
      this.form.pageSize = Math.max(1, Math.min(50, this.form.pageSize));
      this.form.autoPageTime = Math.max(5, Math.min(60, this.form.autoPageTime));
      this.form.refreshInterval = Math.max(60, Math.min(3600, this.form.refreshInterval));
    },

    save() {
      this.$refs.settingForm.validate(isValid => {
        if (isValid) {
          const monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING')) || {};

          // 更新表格展示模式配置
          monitorSetting.displayMode = this.form.displayMode;
          monitorSetting.pageSize = this.form.pageSize;
          monitorSetting.autoPageTime = this.form.autoPageTime;

          // 更新主题风格配置
          monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE = this.form.theme;

          // 更新数据刷新间隔配置
          monitorSetting.refreshInterval = this.form.refreshInterval;

          // 保存到localStorage
          localStorage.setItem('MONITOR_SETTING', JSON.stringify(monitorSetting));

          // 通知主页面刷新配置
          this.utils.event_hub.$emit('SetModelManageLayout');

          this.$message({
            type: 'success',
            message: this.$t('peizhibaocunchenggong')
          });
        } else {
          this.$message({
            type: 'error',
            message: this.$t('qingwanshanpeizhixinxi')
          });
          return false;
        }
      });
    },

    handleModeChange() {
      if (this.form.displayMode === 'page') {
        if (!this.form.pageSize || this.form.pageSize < 1 || this.form.pageSize > 50) {
          this.form.pageSize = 10;
        }
        if (!this.form.autoPageTime || this.form.autoPageTime < 5 || this.form.autoPageTime > 60) {
          this.form.autoPageTime = 10;
        }
      }
    }
  }
};
</script>
